/* A/B test "landing-embedded-pdp".
 *
 * TEST arm: replace the landing's closing "Learn more" section (#preorder) with
 * the full PDP, fetched from the product page and injected inline, so a visitor
 * can add to cart without the extra hop to the product page.
 * CONTROL arm: the page as server-rendered (the closing section stays).
 *
 * Config comes from window.RK_AB_PDP (set inline by rose-kit-landing.liquid):
 *   { flag, productUrl, pdpCss, pdpJs }
 *
 * QA override: ?rk_pdp_embed=1 forces TEST, ?rk_pdp_embed=0 forces CONTROL.
 * Fails safe to CONTROL on any error, missing config, or if flags never resolve.
 */
(function () {
  var cfg = window.RK_AB_PDP || {};
  var FLAG = cfg.flag || 'landing-embedded-pdp';
  var closing = document.getElementById('preorder');
  if (!closing || !cfg.productUrl) { return; }

  var activated = false;

  function activateTest() {
    if (activated) { return; }
    activated = true;

    fetch(cfg.productUrl, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var pdp = doc.querySelector('[data-rk-pdp]');
        if (!pdp) { return; } // fail safe: leave control in place

        // Drop the PDP's own bigfoot footer so the landing's footer isn't doubled.
        var foot = pdp.querySelector('.rk-bigfoot');
        if (foot) { foot.remove(); }

        // Same for the PDP's sale banner: the landing already renders one at the
        // top of the page, so keeping this one strands a second orange strip
        // partway down the scroll.
        var banner = pdp.querySelector('.rk-banner');
        if (banner) { banner.remove(); }

        var wrap = document.createElement('div');
        wrap.className = 'rk-embedded-pdp';
        wrap.appendChild(document.importNode(pdp, true));

        // Tag add-to-carts from here distinctly so the embed is separable from the
        // real PDP page in analytics (product_added_to_cart reads data-ph-source).
        var embForm = wrap.querySelector('#rk-pdp-product-form, form.rk-pdp-form');
        if (embForm) { embForm.setAttribute('data-ph-source', 'landing_pdp_embed'); }

        closing.parentNode.replaceChild(wrap, closing);

        // The PDP's stylesheet (loaded after the landing CSS so it wins conflicts).
        if (cfg.pdpCss && !document.querySelector('link[data-rk-pdp-css]')) {
          var link = document.createElement('link');
          link.rel = 'stylesheet';
          link.href = cfg.pdpCss;
          link.setAttribute('data-rk-pdp-css', '');
          document.head.appendChild(link);
        }

        // Load the PDP script AFTER injection so its IIFE binds to the injected DOM.
        if (cfg.pdpJs) {
          var s = document.createElement('script');
          s.src = cfg.pdpJs;
          document.body.appendChild(s);
        }
      })
      .catch(function () { /* fail safe: control stays */ });
  }

  // QA override, independent of PostHog.
  try {
    var forced = new URLSearchParams(location.search).get('rk_pdp_embed');
    if (forced === '1') { activateTest(); return; }
    if (forced === '0') { return; }
  } catch (e) {}

  // PostHog-bucketed. Calling getFeatureFlag inside onFeatureFlags records the
  // experiment exposure. Give up after 3s (stay control) so we never inject late.
  if (!window.posthog || !posthog.onFeatureFlags) { return; }
  var handled = false;
  var giveUp = setTimeout(function () { handled = true; }, 3000);
  posthog.onFeatureFlags(function () {
    if (handled) { return; }
    handled = true;
    clearTimeout(giveUp);
    try {
      if (posthog.getFeatureFlag(FLAG) === 'test') { activateTest(); }
    } catch (e) {}
  });
})();
